// Statsig client SDK config. Key/tier are injected at runtime via
// env-config.js (window.__env__).

const isEnvObjectSet = typeof window !== "undefined" && !!window.__env__;

export const STATSIG_SDK_KEY: string =
  (isEnvObjectSet && window.__env__.STATSIG_API_KEY) || "";

export const STATSIG_ENV_TIER: string =
  (isEnvObjectSet && window.__env__.STATSIG_ENV) || "";
